import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    templates: [
        {
            id: "generalProject-ProjectStatus-OnHold", // Unique identifier
            table: "generalProject",
            field: "ProjectStatus",
            value: "On Hold",
            recipients: ["david.neesen@watertronics.com"],
            subject: "Job Status Change Notice - {{jobnumber}} {{projectname}}",
            body: `
                <p>The project status for <strong>{{jobnumber}}</strong> - <strong>{{projectname}}</strong> has changed to <strong style="color: red;">{{value}}</strong>.</p>
            `,
            importance: "High", // Added importance field
        },
        {
            id: "generalProject-ProjectStatus-canceled", // Unique identifier
            table: "generalProject",
            field: "ProjectStatus",
            value: "canceled",
            recipients: ["david.neesen@watertronics.com"],
            subject: "Job Status Change Notice - {{jobnumber}} {{projectname}}",
            body: `
                <p>The project status for <strong>{{jobnumber}}</strong> - <strong>{{projectname}}</strong> has changed to <strong style="color: red;">{{value}}</strong>.</p>
            `,
            importance: "High", // Added importance field
        },
    ], // Array of notification templates
};

const fieldNotifyTemplateSlice = createSlice({
    name: "fieldNotifyTemplate",
    initialState,
    reducers: {
        addTemplate: (state, action) => {
            const index = state.templates.findIndex((template) => template.id === action.payload.id);
            if (index !== -1) {
                state.templates[index] = action.payload; // Update existing template
            } else {
                state.templates.push(action.payload); // Add new template
            }
        },
        removeTemplate: (state, action) => {
            state.templates = state.templates.filter((template) => template.id !== action.payload);
        },
        resetTemplates: (state) => {
            state.templates = [...initialState.templates]; // Reset templates to initial state
        },
    },
});

export const { addTemplate, removeTemplate, resetTemplates } = fieldNotifyTemplateSlice.actions;

export default fieldNotifyTemplateSlice.reducer;
